<template>
	<div class="wages wrapper shadow">
		<div class="operation">
			<div class="left">
				<div class="main-title">部门月度工资明细表</div>
			</div>
			<div class="right">
				<el-button type="primary" @click="goFirstPage">首页</el-button>
				<el-button type="primary" @click="goPrevPage">上一页</el-button>
				<span>第{{query.page}}页/共{{query.pages}}页</span>
				<el-button type="primary" @click="goNextPage">下一页</el-button>
				<el-button type="primary" @click="goLastPage">尾页</el-button>
				<el-select v-model="query.pagesize" placeholder="请选择" @change="changePageSize">
					<el-option label="10" value="10"></el-option>
					<el-option label="20" value="20"></el-option>
					<el-option label="30" value="30"></el-option>
					<el-option label="40" value="40"></el-option>
					<el-option label="50" value="50"></el-option>
                    <el-option label="100" value="100"></el-option>
                    <el-option label="200" value="200"></el-option>
				</el-select>
			</div>
		</div>
		<iframe :src="query.url" frameborder="0" width="100%" height="1000px"></iframe>
	</div>
</template>
<script setup>
	import {
		ref
	} from "@vue/reactivity";
	import {
		onMounted
	} from "vue";
	import {
		useRouter
	} from "vue-router";

	const query = ref({
		month: "",
		departmentId: "",
		sort: "+id",
		page: 1,
		pagesize: 10,
		total: 0,
		pages: 0,
		type: 1,
		url: ''
	});

	const calcPages = () => {
		query.value.pages = Math.ceil(query.value.total / query.value.pagesize);
	}

	//跳到首页
	const goFirstPage = () => {
		query.value.page = 1;
		showReport();
	}
	//上一页
	const goPrevPage = () => {
		if (query.value.page > 1) {
			query.value.page--;
			showReport();
		}
	}
	//下一页
	const goNextPage = () => {
		if (query.value.page < query.value.pages) {
			query.value.page++;
			showReport();
		}
	}
	//跳到尾页
	const goLastPage = () => {
		query.value.page = query.value.pages;
		showReport();
	}

	const changePageSize = (pagesize) => {
		query.value.pagesize = pagesize;
		query.value.page = 1;
		calcPages();
		showReport();
	}

	onMounted(() => {
		let params = useRouter().currentRoute.value.query;
		query.value.total = params.total
		query.value.month = params.month
		query.value.departmentId = params.departmentId
		query.value.type = params.type
		calcPages()
		showReport();
	});

	const showReport = () => {
		let reportFile = '784272325386964992';
		if (query.value.type == 2) {
			reportFile = '786737058031661056';
		}
        if (query.value.type == 3) {
            reportFile = '791458572270309376';
            query.value.pagesize = 200;
            calcPages();
        }
		query.value.url = process.env.VUE_APP_REPORT_URL + reportFile +
			"?token=" +
			localStorage.getItem("token") +
			"&month=" + query.value.month +
			"&departmentId=" + query.value.departmentId +
            "&sort=-person.sort,+person.id" +
			"&page=" + query.value.page +
			"&pagesize=" + query.value.pagesize
	}
</script>
<style lang="scss" scoped>
	.operation{
		.right{
			align-items: center;
			span{
				margin: 0 10px;
			}
			.el-select{
				width: 100px;
				margin: 0 0 0 10px;
			}
		}
	}
</style>
